import { graphql } from "gatsby"
import React from "react"
import Helmet from "react-helmet"
import Modal from "../components/ProductsModal/ProductsModal"
import Layout from "../components/SubLayout"
import { navItemsEn } from "../constants/navigation"
import { Container, ProductWrapper } from "../styled/products"
class Product extends React.Component {
  render() {
    return (
      <Layout
        data={this.props.data}
        location={this.props.location}
        navItems={navItemsEn}
      >
        <Helmet
          title="Products - Miia"
          meta={[
            { name: "description", content: "Sampleee" },
            { name: "keywords", content: "sampleee, something" },
          ]}
        />
        <Container>
          <ProductWrapper>
            <Modal
              data={this.props.data}
              title={"See details"}
              subTitles={["maintenance", "Size", "Weight"]}
            />
          </ProductWrapper>
        </Container>
      </Layout>
    )
  }
}

export default Product

export const productQuery = graphql`
  query ProductQuery {
    site {
      siteMetadata {
        languages {
          defaultLangKey
          langs
        }
      }
    }
    mainlogo: file(relativePath: { eq: "logo.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
      }
    }
    us: allContentfulProduct(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          title
          id
          contentful_id
          maintenance
          size
          weight
          image {
            title
            description
            url
          }
        }
      }
    }
  }
`
